import { ButtonText } from 'shared/ui/buttons/buttonText';
import { PayloadAction } from '@reduxjs/toolkit';
import { FC, useEffect, useMemo } from 'react';

import { useModal } from 'shared/lib/modal';
import { Confirm } from 'shared/ui/confirm';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { Order, useOrderState } from 'entities/orders';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';

interface OrderDetailCloseConfirmProps {
	save: () => Promise<PayloadAction<unknown> | void>;
	close?: () => void;
	back: () => void;
	order?: Order | null;
	applicationMod?: boolean;
}

export const OrderDetailCloseConfirm: FC<OrderDetailCloseConfirmProps> = ({
	save,
	close,
	back,
	order,
	applicationMod,
}) => {
	const { closeModal, openModal } = useModal();
	const { isWaitingList } = useOrderState(order);

	const title = useMemo(() => {
		if (applicationMod) {
			return `У заявки ${order?.id || ''} есть несохраненные изменения!`;
		} else {
			if (isWaitingList) {
				return `Все изменения в заявке ${order?.id || ''
					} будут потеряны. \n Вы уверены, что хотите выйти из бронирования?`;
			} else {
				return `У бронирования ${order?.id || ''
					} есть несохраненные изменения!`;
			}
		}
	}, [isWaitingList, applicationMod, order]);

	const handleCloseOrder = async () => {
		close?.();
		closeModal();
	};

	const handleCloseModal = async () => {
		back?.();
		closeModal();
	};

	useEffect(() => {
		openModal();
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<Confirm
				title={title}
				confirmButton={
					applicationMod ? (
						<>
							<ButtonContained
								color="default"
								isFullWidth={true}
								onClick={save}
							>
								Сохранить и закрыть
							</ButtonContained>
							<ButtonText
								color="danger"
								isFullWidth
								onClick={handleCloseOrder}
							>
								Закрыть без сохранения
							</ButtonText>
						</>
					) : (
						<>
							{isWaitingList ? (
								<ButtonOutlined
									color="danger"
									isFullWidth
									onClick={handleCloseOrder}
								>
									Да
								</ButtonOutlined>
							) : (
								<>
									<ButtonContained
										color="default"
										isFullWidth={true}
										onClick={save}
									>
										Сохранить и закрыть
									</ButtonContained>
									<ButtonText
										color="danger"
										isFullWidth
										onClick={handleCloseOrder}
									>
										Закрыть без сохранения
									</ButtonText>
								</>
							)}
						</>
					)
				}
				cancelButtonLabel={
					applicationMod
						? 'Вернуться к редактированию'
						: isWaitingList
							? 'Нет'
							: 'Вернуться к редактированию'
				}
				cancelButtonContained={!applicationMod && isWaitingList}
				buttonsReversed={!applicationMod && isWaitingList}
				onClose={handleCloseModal}
			/>
		</>
	);
};
